export const getLocation = () => {
  if (typeof window !== 'undefined') {
    return window.location
  }
}
